import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";
import Tendency_Icon from "@assets/svg/tendency_up.svg";

export const TendencyContent = styled.div`
    display:flex;
    align-items: center;
    width:10px;
    justify-content: center;
    position: relative;

     span {
        display:none;
        bottom: 0%;
        left:14px;
        font-size:8px;
        width:10px;
    }

    svg{
        height:10px;
    }

    div{ 
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

export const TendencyDown = styled(Tendency_Icon)<{showPresence:boolean}>`
    transform: ${props => props.showPresence?"rotate(0deg)":"rotate(90deg)"};
    path{
        fill:#2A848E;
    }
`;

export const TendencyUp = styled(Tendency_Icon)<{showPresence:boolean}>`
    transform: ${props => props.showPresence?" rotate(90deg)":"rotate(0deg)"};
    path{
        fill:#FA505E;
    }
`;